import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceManagementService } from 'src/app/device/device-management.service';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { UsersService } from 'src/app/users/users.service';
import { ValidationService } from 'src/app/shared/services/validation.service';

interface FailedForceReadDebugDevice {
	mac_address: string;
	reason: string;
}

interface MultiForceReadDebugResult {
	total: number;
	success: number;
	failed: number;
	failed_devices: FailedForceReadDebugDevice[];
}

@Component({
	selector: 'app-multi-force-read-debug',
	templateUrl: './multi-force-read-debug.component.html',
	styleUrls: ['./multi-force-read-debug.component.css']
})
export class MultiForceReadDebugComponent implements OnInit {

	macAddressesInput: string = '';
	force_read_debug_time: number = null;

	invalidMacAddresses: string[] = [];
	result: MultiForceReadDebugResult = null;
	isSubmitting: boolean = false;

	minAllowedDebugHours: number = 0;
	maxAllowedDebugHours: number = 72;

	constructor(
		private deviceManagementService: DeviceManagementService,
		private notificationMessage: NotificationMessageService,
		private usersService: UsersService,
		private router: Router,
		private sideMenuService: SideMenuService,
		private validationService: ValidationService,
	) { }

	ngOnInit() {
		if (!this.usersService.hasAccessPermission(null, 'noc'))
			return this.router.navigate(['/unauthorized']);

		this.sideMenuService.hide();
	}

	saveDebugDate(isForceNow: boolean = false) {
		const macAddresses = this.getNormalizedMacAddresses();
		this.invalidMacAddresses = macAddresses.filter((macAddress) => !this.validationService.macRegex.test(macAddress));
		this.result = null;

		if (!macAddresses.length)
			return this.notificationMessage.setMessage('translate|g.field_is_required');

		if (this.invalidMacAddresses.length)
			return this.notificationMessage.setMessage('translate|multi_force_read_debug.invalid_mac_addresses');

		if (!isForceNow && (this.force_read_debug_time == null || this.force_read_debug_time > this.maxAllowedDebugHours || this.force_read_debug_time < this.minAllowedDebugHours))
			return this.notificationMessage.setMessage('translate|force_read_debug.select_time_more_max_time');

		this.isSubmitting = true;
		this.deviceManagementService.setBulkForceReadDebugDate(macAddresses, this.force_read_debug_time, isForceNow).subscribe((res: MultiForceReadDebugResult) => {
			this.result = res;
			this.isSubmitting = false;
			this.notificationMessage.setMessage('globalSuccessMsg', { clearOnXTimeNavigate: 1 });
		}, () => {
			this.isSubmitting = false;
		});
	}

	private getNormalizedMacAddresses(): string[] {
		return this.macAddressesInput
			.split(/[,\n]/)
			.map((macAddress) => macAddress.trim())
			.filter((macAddress) => macAddress);
	}
}
